/** Mirrors server/src/lib/constants.js. These exact strings are stored values. */

export const MEETING_TYPES = ['رسمي', 'مواطنين', 'ميدانية', 'اتصال', 'أخرى'];

export const MEETING_TYPE_LABELS = {
  رسمي: 'اجتماع رسمي',
  مواطنين: 'استقبال مواطنين',
  ميدانية: 'زيارة ميدانية',
  اتصال: 'اتصال هاتفي',
  أخرى: 'أخرى',
};

export const STATUS_UPCOMING = 'قادم';
export const STATUS_COMPLETED = 'مكتمل';
export const STATUS_CANCELLED = 'ملغى';

export const MEETING_STATUSES = [STATUS_UPCOMING, STATUS_COMPLETED, STATUS_CANCELLED];

export const ROLE_LABELS = {
  admin: 'مدير النظام',
  staff: 'موظف المكتب',
  viewer: 'عرض فقط',
};

export function typeLabel(type) {
  return MEETING_TYPE_LABELS[type] || type || '';
}

/** True when the role may create, edit, or delete appointments. */
export function canEdit(user) {
  return user?.role === 'admin' || user?.role === 'staff';
}

export function isAdmin(user) {
  return user?.role === 'admin';
}
